import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { Router } from "./Router";
import { Toaster } from "./view/components/ui/toaster";
import { AuthProvider } from "./app/contexts/AuthContext";
import { WhitelabelProvider } from "./app/contexts/whitelabelContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <WhitelabelProvider>
        <AuthProvider>
          <Router />
          <Toaster />
        </AuthProvider>
      </WhitelabelProvider>

      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
